export const CREATE_COHORT_SUCCESS="cohort/CREATE_COHORT_SUCCESS";
export const CREATE_COHORT_FAILURE="cohort/CREATE_COHORT_FAILURE";
export const COHORT_LIST_SUCCESS="cohort/COHORT_LIST_SUCCESS";
export const COHORT_LIST_FAILURE="cohort/COHORT_LIST_FAILURE";
export const DELETE_COHORT_SUCCESS="cohort/DELETE_COHORT_SUCCESS";
export const DELETE_COHORT_FAILURE="cohort/DELETE_COHORT_FAILURE";
export const UPDATE_COHORT_SUCCESS = "UPDATE_COHORT_SUCCESS";
export const UPDATE_COHORT_FAILURE = "UPDATE_COHORT_FAILURE";